export default "__VITE_ASSET__0283d58c__"